export default __webpack_public_path__ + "static/media/200points.9a92b533.jpg";